import {ThunkResult} from "../../main/reducers/IMainAppState";
import * as queryString from "query-string";
import {APIGet} from "../../shared/actions/FetchActions";

export type OAuthType = "facebook"|"google";

export function GetOAuthPath(oauthType: OAuthType, state: string): ThunkResult<Promise<string>> {
    return async dispatch => {
        const fetchResult: Response = await dispatch(APIGet(`/oa/${oauthType}`));
        const {clientId}: {clientId: string} = await fetchResult.json();
        switch(oauthType) {
            case "facebook":
                return dispatch(GetFacebookOAuthPath(clientId, state));
            case "google":
                return dispatch(GetGoogleOAuthPath(clientId, state));
        }
    };
}

function getOAuthResponseURI(oauthType: OAuthType): ThunkResult<string> {
    return () => {
        const domainComponents = window.location.host.split(".");
        let domain;
        if(domainComponents.length > 2) {
            domain = domainComponents[domainComponents.length - 2] + "." + domainComponents[domainComponents.length - 1]
        } else {
            domain = window.location.host;
        }
        return `${window.location.protocol}//${domain}/oa/${oauthType}/action/_auth`;

    }
}

export function GetFacebookOAuthPath(clientId: string, state: string): ThunkResult<string> {
    return dispatch => {
        const oauthURL: string = "https://www.facebook.com/dialog/oauth";
        const params = {
            "response_type": "code",
            "client_id": clientId,
            "redirect_uri": dispatch(getOAuthResponseURI("facebook")),
            "scope": "public_profile,email",
            "state": state
        };
        return `${oauthURL}?${queryString.stringify(params)}`;
    }
}

export function GetGoogleOAuthPath(clientId: string, state: string): ThunkResult<string> {
    return dispatch => {
        const oauthURL: string = "https://accounts.google.com/o/oauth2/v2/auth";
        const params = {
            "access_type": "offline",
            "include_granted_scopes": "true",
            "response_type": "code",
            "client_id": clientId,
            "redirect_uri": dispatch(getOAuthResponseURI("google")),
            "scope": "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
            "state": state
        };
        return `${oauthURL}?${queryString.stringify(params)}`;
    }
}